/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IMessagePageOwnProps, IMessagePageStateProps, IMessagePageDispatchProps, MessagePage } from "../../components/message/MessagePage/MessagePage";
import { ITypedOption } from "../../models/common/typedOption";
import { getMessagePage, MessageThunkDispatch } from "source/models/store/message";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IMessagePageOwnProps): IMessagePageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            messagePage: null
        };
    }
    const message = applicationState.message;
    return {
        appState: applicationState.session,
        dataId: message.page.dataId,
        messagePage: message.page.messagePage
    };
}

export function mapDispatchToProps(dispatch: MessageThunkDispatch): IMessagePageDispatchProps {
    return {
        onGetMessagePage: () => dispatch(getMessagePage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IMessagePageStateProps, IMessagePageDispatchProps, IMessagePageOwnProps>(mapStateToProps, mapDispatchToProps)(MessagePage);